import Link from "next/link";
import { Logo } from "./Logo";

const footerLinks = {
  Product: [
    { label: "Features", href: "#features" },
    { label: "Pricing", href: "#pricing" },
    { label: "Changelog", href: "#" },
    { label: "Roadmap", href: "#" },
  ],
  Resources: [
    { label: "Documentation", href: "#" },
    { label: "API Reference", href: "#" },
    { label: "Guides", href: "#" },
    { label: "Blog", href: "#" },
  ],
  Company: [
    { label: "About", href: "#" },
    { label: "Careers", href: "#" },
    { label: "Contact", href: "#" },
    { label: "Press", href: "#" },
  ],
  Legal: [
    { label: "Privacy", href: "#" },
    { label: "Terms", href: "#" },
    { label: "Security", href: "#" },
  ],
};

export function Footer() {
  return (
    <footer className="py-10 sm:py-14 md:py-16 lg:py-20 bg-white border-t border-border">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-[2fr_1fr_1fr_1fr_1fr] gap-6 sm:gap-8 md:gap-10 lg:gap-12 mb-8 sm:mb-12 md:mb-16">
          {/* Brand Column */}
          <div className="col-span-2 sm:col-span-2 md:col-span-3 lg:col-span-1 mb-4 lg:mb-0">
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-5">
              <Logo className="w-7 h-7 sm:w-8 sm:h-8" />
              <span className="font-bold text-base sm:text-lg text-text">Specledger</span>
            </div>
            <p className="text-xs sm:text-sm text-text-muted leading-relaxed max-w-[280px]">
              The single source of truth for spec-driven development. Keep
              humans and AI aligned from requirements to implementation.
            </p>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <p className="text-[10px] sm:text-xs font-bold text-text uppercase tracking-[1px] mb-3 sm:mb-4 md:mb-5">
                {title}
              </p>
              <ul className="space-y-2 sm:space-y-3 md:space-y-3.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      href={link.href}
                      className="text-xs sm:text-sm text-text-muted no-underline transition-colors hover:text-primary"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col sm:flex-row justify-between items-center pt-6 sm:pt-8 border-t border-border gap-4">
          <p className="text-[11px] sm:text-[13px] text-text-muted order-2 sm:order-1">
            © 2025 Specledger. All rights reserved.
          </p>
          <div className="flex gap-4 sm:gap-6 order-1 sm:order-2">
            <Link
              href="https://x.com/specledger"
              className="text-[11px] sm:text-[13px] text-text-muted no-underline transition-colors hover:text-primary"
            >
              Twitter
            </Link>
            <Link
              href="http://github.com/specledger"
              className="text-[11px] sm:text-[13px] text-text-muted no-underline transition-colors hover:text-primary"
            >
              GitHub
            </Link>
            <Link
              href="https://discord.gg/b6j9ygry"
              className="text-[11px] sm:text-[13px] text-text-muted no-underline transition-colors hover:text-primary"
            >
              Discord
            </Link>
            <Link
              href="https://www.linkedin.com/company/specledger/"
              className="text-[11px] sm:text-[13px] text-text-muted no-underline transition-colors hover:text-primary"
            >
              LinkedIn
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
